import React, { useEffect } from 'react';
import AdspRegistrationPage from 'src/pages/adspRegistration/page';
import { fetchSauronContext } from 'src/shared/state/redux';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'src/shared/state/store';

/**
 * Route component for the dedicated ADSP registration path
 * (/ads-account/registration/adsp). The flow is encoded in the path (not the
 * adProductGroup query parameter) so the Mons gateway can keep this route
 * challenge-free for the AdOps flow while the SA route carries Policy15.
 * Server-side, ARMS 404s this path for sessions without ADSP permissions.
 */
const AdspRegistrationRouter = () => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchSauronContext());
  }, [dispatch]);

  return <AdspRegistrationPage />;
};

export default AdspRegistrationRouter;
